import { createFileRoute, redirect } from '@tanstack/react-router';

/** `/content/review` — review now lives inside each run, so the old queue URL lands on Runs. */
export const Route = createFileRoute('/_authenticated/_tenant/content/review')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({ to: '/content/runs' });
  },
});
